export const btnPrimary =
  "inline-flex h-12 items-center justify-center gap-2 rounded-full bg-ink px-7 text-sm font-medium text-paper transition-[background-color,transform] duration-150 ease-out hover:bg-gold-deep active:scale-[0.98] disabled:opacity-60";

export const btnSecondary =
  "inline-flex h-12 items-center justify-center gap-2 rounded-full border border-ink/15 bg-paper px-7 text-sm font-medium text-ink transition-[border-color,transform] duration-150 ease-out hover:border-ink active:scale-[0.98]";

export const btnLight =
  "inline-flex h-12 items-center justify-center gap-2 rounded-full bg-paper px-7 text-sm font-medium text-ink transition-[background-color,transform] duration-150 ease-out hover:bg-sand active:scale-[0.98]";

export const container = "mx-auto max-w-[1400px] px-5 lg:px-10";

export const ease = [0.23, 1, 0.32, 1] as const;
